/** @jsxImportSource @emotion/react */
import { css, useTheme } from "@emotion/react";
import { useLanguage } from "LanguageContext";
import React from "react";

export default function InformationText() {
  const { t } = useLanguage();
  const theme = useTheme();

  const textStyles = css`
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    font-family: ${theme.typography.subbody_medium.fontFamily};
    font-size: ${theme.typography.subbody_medium.fontSize};
    font-weight: ${theme.typography.subbody_medium.fontWeight};
    line-height: ${theme.typography.subbody_medium.lineHeight};
    color: ${theme.typography.subbody_medium.colors};
    margin-top: ${theme.spacing.xxl};
  `;

  return <div css={textStyles}>{t("analyse_disclaimer_information")}</div>;
}
